// Contract addresses per network. Fill in real addresses after deploy.
export const CONTRACTS = {
  mainnet: {
    ADNFTV2: '0x7Fc305b782C4EDF4e0b29438f96FAD3Ed91bd040',
    USDT:    '0x9e5AAC1Ba1a2e6aEd6b32689DFcF62A509Ca96f3' // opBNB mainnet USDT (BEP-20, 18 decimals)
  },
  testnet: {
    ADNFTV2: '0xe7220f855bbca5a189bb9a3b4d1e4c75059958dd',
    USDT:    '0xBf6596a279172D330b8b732D257Ee633B6FDA911'  // deploy a mock 18-dec USDT for testing
  }
};
